import { render } from "./TransferTop.vue?vue&type=template&id=2cb5878f&scoped=true"
import script from "./TransferTop.vue?vue&type=script&lang=js"
export * from "./TransferTop.vue?vue&type=script&lang=js"

import "./TransferTop.vue?vue&type=style&index=0&id=2cb5878f&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1700309314/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cb5878f"]])

export default __exports__